// components/ContractList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { AppBarHeader } from '../common/common';
import ContractCard from '../common/ContractCard';
import api from '../../core/axiosInstance';

const ContractList = () => {
  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);

  useEffect(() => {
    api
      .get('/api/contracts/me')
      .then((response) => {
        setContracts(response.data);
      })
      .catch((error) => {
        console.error('Error fetching contracts:', error);
      });
  }, []);

  return (
    <>
      <AppBarHeader title="การ์ดลูกหนี้" />
      <Container sx={{ mt: 2 }}>
        {contracts.map((c) => (
          <ContractCard
            key={c.id}
            contract={c}
            onClick={() => navigate(`/contracts/${c.id}`)}
          />
        ))}
      </Container>
    </>
  );
};

export default ContractList;
